import {NgModule} from '@angular/core';
import {CoreModule} from '../core/core.module';
import {ZonePipe} from './zone.pipe';
import {ZonesPipe} from './zones.pipe';

@NgModule({
  declarations: [
    ZonePipe,
    ZonesPipe
  ],
  imports: [
    CoreModule,
  ],
  exports: [
    ZonePipe,
    ZonesPipe
  ],
  providers: [
    ZonePipe,
    ZonesPipe
  ],
})
export class ZoneModule {
}
